@if (formControl() && types()) {
<div class="type form-group">
    <mat-form-field class="form-field">
        <mat-label>{{meta().name}}</mat-label>
        <mat-select [multiple]="!!meta()?.multiple" [formControl]="formControl()!">
            @if (!meta()?.multiple) {
            <mat-option>--</mat-option>
            }
            @for (option of types() | keyvalue; track option.key) {
            <mat-option [value]="option.key">
                {{option.value.name}}
            </mat-option>
            }
        </mat-select>
        <mat-hint><strong>{{meta()?.info}}</strong></mat-hint>
        @if (formControl()?.hasError('required')) {
        <mat-error>
            {{meta()?.name}} is <strong>required</strong>
        </mat-error>
        }
        @if (formControl()?.hasError('form')) {
        <mat-error>
            {{formError}}
        </mat-error>
        }
    </mat-form-field>
</div>
}
